(function attachImmersiveProduct(root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.MonciProductImmersive = api;
})(typeof globalThis === 'undefined' ? window : globalThis, function createImmersiveProduct() {
  function visibleMediaIds(items, activeId, paired) {
    const index = items.findIndex((item) => item.id === activeId);
    if (index < 0) return [];
    const visible = [activeId];
    if (!paired || !items[index].image) return visible;
    for (const candidate of items) {
      if (candidate.image && candidate.id !== activeId) {
        visible.push(candidate.id);
        break;
      }
    }
    return visible;
  }
  return { visibleMediaIds };
});
